import { Component } from '@angular/core';
import {
  VerbalService,
  VerbalAudioType,
} from 'src/app/modules/read-aloud/services/verbal.service';
import { AudioDescriptor } from 'src/app/shared/enums/audio-descriptor';
import { AudioType } from 'src/app/shared/enums/audio-type';

@Component({
  selector: 'htc-verbal-prompt-button',
  templateUrl: './verbal-prompt-button.component.html',
  styleUrls: ['./verbal-prompt-button.component.scss'],
  standalone: false,
})
export class VerbalPromptButtonComponent {
  readonly path = '/assets/toolbar-icons/';
  icon = 'verbal_prompt.svg';
  testId = 'htc-verbal-prompt-button';
  clickDescriptor = AudioDescriptor.SELECT_MINOR;
  clickType = AudioType.audio_SfxClick;

  constructor(private verbalService: VerbalService) {}

  onClick(): void {
    this.verbalService.playPopulationAudio(VerbalAudioType.PROMPT);
  }
}
